import ProfileNonAcademicRequirements from './ProfileNonAcademicRequirements.component';

export default ProfileNonAcademicRequirements;